import { statAssets } from '../../constants/assets'

/** The dark circle with the diagonal "open" arrow in the corner of every stat card. */
export const OpenIndicator = () => (
  <span className="flex size-[26px] shrink-0 items-center justify-center rounded-full bg-dash-ink">
    <span className="relative block h-[22px] w-[21px] overflow-hidden">
      <span className="absolute bottom-[24.71%] left-[24.7%] right-[24.81%] top-1/4 block -scale-y-100">
        <img alt="" aria-hidden className="block size-full max-w-none" src={statAssets.openArrow} />
      </span>
    </span>
  </span>
)
